import api from "../../config/client.axios.api";

export const deleteStoreApi = async (groupId: any) => {
  const response = await api.delete(`/store`, {
    params: {
      groupId,
    },
  });
  return response.data;
};
